import {createContext, FC, useContext, useState} from 'react'
import {WithChildren, initialQueryState, QueryState} from '../../../../_metronic/helpers'

type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

const QueryRequestContext = createContext<QueryRequestContextProps>({
  state: initialQueryState,
  updateState: () => {},
})

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<QueryState>(initialQueryState)

  const updateState = (updates: Partial<QueryState>) =>
    setState((prev) => ({...prev, ...updates}))

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)

export {QueryRequestProvider, useQueryRequest}
